import { Col, Divider, Popconfirm, Popover, Row } from 'antd';
import { InfoCircleFilled, InfoCircleTwoTone } from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  customGTMEvent, getNextAllowStatus,
  panValidationUpload,
  setIsShowNow, convertToISOStrings,
  getIsPageNameDetail,
  documentUploadFlow,
  booleanToYesNo,
  getLettersFromPatientDetails,
  prefillHISDynamicFields,
  getParsedAttributesObject,
  fillFormValuesFromHIS,
} from '../../../modules/crm/inPatient/service/crmUtils';
import { RootState } from '../../../store';
import { setClaimData } from '../../../store/actions/claimDetailsAction';
import { getDateWithTextMonth } from '../../../utils/dateTimeUtils';
import { AADHAR_VALIDATOR, GUTTOR_SPACE, MASKADHAAR } from '../../constants/commonConstants';
import {
  BY_COURIER, BY_HAND, DYNAMIC_FIELD_MAPPINGS, HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW,
  ICICI_DOCUMENT_SUBMISSION_OPTIONS, ICICI_TYPE_OF_CLAIM_OPTIONS, MAX_LOS_ALLOWED_WITHOUT_WARNING,
  NEW_UPLOAD_STATUS,
  NON_HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW,
  PARAMOUNT_SETTLEMENT_BRANCH_OPTIONS, PARAMOUNT_SETTLEMENT_DOCUMENT_TYPE_OPTIONS, RADIO_SWITCH_OPTION,
  VIDAL_SETTLEMENT_DOCUMENT_TYPE_OPTIONS,
} from '../../constants/crmConstants';
import { FormCheckBox, FormInputDate, FormRadioButton, FormSelect, FormTextInput } from '../crmFormElement/FormInput';
import { setAdmissionForm, setIsDischargeCase, setModalSwitch, updateSettlementType } from '../../../store/actions/newAdmissionAction';
import { Payer } from '../../models/payer.model';
import BuddhiMedFileUpload from './buddhimedFileUpload/BuddhiMedFileUpload';
import DocumentChecklist from './DocumentChecklist';
import SettlementCard from './SettlementCard';
import CourierDetail from './CourierDetails';
import ClaimDetailHeader from '../../../modules/crm/inPatient/newAdmission/panels/cards/ClaimDetailHeader/ClaimDetailHeader';
import FormMultiEmailInput from '../crmFormElement/FormMultiEmailInput/FormMultiEmailInput';
import { NewAdmissionState } from '../../../store/models/newAdmissionModel';
import { setSettlementValue } from '../../../store/actions/inPatientAction';
import ClassifiedDocuments from '../ClassifiedDocuments/ClassifiedDocuments';
import FormInputNumber from '../crmFormElement/FormInputNumber/FormInputNumber';
import { setExactFileCount } from '../../../store/actions/payerListAction';
import FormFormattedAmount from '../crmFormElement/FormFormattedAmount/FormFormattedAmount';
import { isEmpty } from 'lodash';
import { startOfDay, isBefore } from 'date-fns';
import DatePickerInput from '../crmFormElement/FormInputDatepicker';
import NonHISBuddhimedFileUpload from './buddhimedFileUpload/NonHISBuddhimedFileUpload';
import ApplicationDetail from '../../services/applicationDetail.service';
import HISBuddhimedFileUpload from './buddhimedFileUpload/HISBuddhimedFileUpload';
import ClassifiedDocumentsRedesign from '../ClassifiedDocuments/ClassifiedDocumentsRedesign';
import { useLocation } from 'react-router-dom';
import DatePickerLabel from '../DatePicker/DatePickerLabel';
import { NHCXState } from '../../../store/models/nhcxModel';
import { setParsedHISValuesMap } from '../../../store/actions/hospitalAction';
import FormCustomMaskedInput from '../crmFormElement/FormCustomMaskedInput/FormCustomMaskedInput';

const UploadSettlementDocs = ({ form, admissionForm, actionName: claimAction, setErrorMessage }: any): ReactElement => {
  const { pathname } = useLocation();
  const mounted = useRef(false);
  const [isChangeBuddhi, setIsChangeBuddhi] = useState(false);
  const [isCourierChange, setIsChangeCourier] = useState(false);
  const dispatch = useDispatch();
  const { claimDetails, isCashlessSubmit } = useSelector((state: RootState): any =>
    state?.admissionDetails || {});
  const { policyStartDate, policyEndDate,
    settlementDocuments, settlementDocumentsDisabled, blockUploadSettlementdocs } =
    useSelector((state: RootState): any => state?.admissionDetails?.claimDetails || {});
  const { isCorporatePayer, isOnMailPayer, isRPAOutboundDisabledPayer } =
    useSelector((state: RootState): Payer => state?.payerList?.payer || {});
  const {
    isDraftBtnClicked,
  } = useSelector((state: RootState): any => state?.selectedInPatientDetail || {});
  const { draftValue, settlementType, uploadedFiles, modalFormValue: { documentType }, newAdmissionSearchValues } =
    useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const [selectedPayerEmails, setSelectedPayerEmails] = useState('');
  const [isLOSgtWarning, setIsLOSgtWarning] = useState(false);
  const [popConfirmCancel, setPopConfirmCancel] = useState(false);
  const [docSubmittedByHandFieldsEnabled, setDocSubmittedByHandFieldsEnabled] = useState(false);
  const [docSubmittedByCourierFieldsEnabled, setDocSubmittedByCourierFieldsEnabled] = useState(false);
  const payer = useSelector((state: RootState): Payer => state?.payerList?.payer || {});
  const { uniqueIdentifier } = payer || {};
  const { payerLookUp }: any = useSelector((state: RootState): RootState => state);
  const { claimDetails: { dateOfAdmission: doa = '', dateOfDischarge: dod = '' } = {} } = useSelector((state: RootState): any =>
    state?.admissionDetails || {});
  const { hospitalSearchPatientDetails, selectedPatientDetail } = useSelector((state: RootState): any => state.hospital);
  const { selectedPolicyDetail, memberName }: any =
    useSelector((state: RootState): NHCXState => state?.nhcx);
  const [dateDifference, setDateDifference] = useState(0);
  const { admissionFormVal } = useSelector((state: RootState): any => state?.newAdmission);
  const appdetail = ApplicationDetail.instance;
  const attachments = getLettersFromPatientDetails(selectedPatientDetail, hospitalSearchPatientDetails);
  const isPreAuthNewDesignEnabled = appdetail?.getIsPreAuthNewDesignEnabled();
  const { dischargeInitiationDetails, patientDetails, caseDetails } = hospitalSearchPatientDetails?.[0] || {};
  const { additionalAttributes: patientDetailsAdditionalAttrs } = patientDetails || {};
  const { additionalAttributes: dischargeDetailsAdditionalAttrs } = dischargeInitiationDetails || {};
  const commonDetail = { form };

  useEffect((): any => {
    const payerData = JSON?.parse(localStorage.getItem('payerConfiguration') || '{}');
    filterSelectedPayerEmails(payerData?.payers);
  }, []);

  const newFileUploads = uploadedFiles?.filter((fileUid: any): any => fileUid?.claimStatus === NEW_UPLOAD_STATUS);

  useEffect((): any => {
    if (dateDifference > 0) {
      setErrorMessage('');
      const formValues = form.getFieldsValue(['stayLength']);
      if (!formValues?.stayLength) {
        return;
      }
      const dateRange = convertToISOStrings(formValues?.stayLength);
      const [admitDateTime, dischargeDateTime] = dateRange || [];
      if (!admitDateTime || !dischargeDateTime) {
        return;
      } else {
        form.validateFields(['stayLength']);
        if (dateDifference > MAX_LOS_ALLOWED_WITHOUT_WARNING) {
          setIsLOSgtWarning(true);
          setPopConfirmCancel(false);
        } else {
          setIsLOSgtWarning(false);
        }
      }
      if (dischargeDateTime) {
        const { allowStatus } = claimDetails;
        const [{ documentName = [], actionName = null } = {}] =
        getNextAllowStatus(allowStatus, dod, claimAction, isCorporatePayer, isCashlessSubmit, false, pathname);
        claimDetails['nextAllowStatus'] = actionName ? [actionName] : [];
        claimDetails['mandatoryClassificationName'] = documentName;
        claimDetails['doa'] = claimDetails['dateOfAdmission'] = admitDateTime;
        claimDetails['dod'] = claimDetails['dateOfDischarge'] = dischargeDateTime;
        claimDetails['stayLength'] = [admitDateTime, dischargeDateTime];
        if (mounted.current) {
          dispatch(setClaimData({ ...claimDetails }));
        }
      }
      if (admitDateTime && dischargeDateTime && isCashlessSubmit) {
        const todayDate = startOfDay(new Date());
        if (isBefore(new Date(dischargeDateTime), todayDate)) {
          setErrorMessage(' ');
        } else {
          setErrorMessage((payer?.shortName === 'RGI' || payer?.shortName === 'ABHI') ? ' ' :
            'Data shows that the patient is still in the hospital, update DOD for initiating settlement or click on "Edit" to enhance a claim request');
        }
      }
      if (!isCashlessSubmit) {
        setErrorMessage(' ');
      }
    }
  }, [dateDifference]);

  const documentFlow = documentUploadFlow(isPreAuthNewDesignEnabled, attachments, claimDetails);

  useEffect((): void => {
    if (draftValue === 'settlement' || settlementType === 'settlement-docs') {
      let stayLength: any = [new Date(doa), new Date(dod)];
      stayLength = convertToISOStrings(stayLength);
      const targetField = payer?.isOnMailPayer ? 'customerDetail' : 'treatmentDetail';
      const newFormVal = {
        ...admissionFormVal,
        [targetField]: {
          ...admissionFormVal[targetField],
          stayLength,
        },
      };
      dispatch(setAdmissionForm(newFormVal));
      if (documentType === BY_HAND) {
        setDocSubmittedByHandFieldsEnabled(true);
      } else if (documentType === BY_COURIER) {
        setDocSubmittedByCourierFieldsEnabled(true);
      }
      form.validateFields(['stayLength']);
    }
    if (!isEmpty(hospitalSearchPatientDetails?.[0])) {
      form.setFieldsValue({
        patientPaidAmount: dischargeInitiationDetails?.paidAmount,
        recieptNo: dischargeInitiationDetails?.receiptNumber,
        inPatientNumber: patientDetails?.inpatientNumber,
        switchClick: booleanToYesNo(caseDetails?.isRTA),
        panNumber: patientDetails?.panCardNo,
      });
    }
  }, [settlementType]);

  const onDocumentTypeChange = (event: any): any => {
    switch (event) {
      case BY_HAND:
        setDocSubmittedByHandFieldsEnabled(true);
        setDocSubmittedByCourierFieldsEnabled(false);
        break;
      case BY_COURIER:
        setDocSubmittedByHandFieldsEnabled(false);
        setDocSubmittedByCourierFieldsEnabled(true);
        break;
      default:
        setDocSubmittedByHandFieldsEnabled(false);
        setDocSubmittedByCourierFieldsEnabled(false);
    }
  };

  const setSelectedTime = (admitDate: any, dischargeDate: any, admitTime: any, dischargeTime: any): void => {
    form?.setFieldsValue({ stayLength: [admitDate?.concat(' ', admitTime), dischargeDate?.concat(' ', dischargeTime)] });
  };
  const dischargeSwitchHandler = (ev: any): any => {
    admissionForm.setFieldsValue({ isDischargeCase: ev?.target?.checked ? 'Yes' : undefined });
    dispatch(setIsDischargeCase(ev.target.checked));
  };
  const nonUtilizedPA = (ev: any): any => {
    admissionForm.setFieldsValue({ switchClick: ev?.target?.checked ? ev?.target?.value : undefined });
  };
  const eventValue = form.getFieldsValue(['settlementType'])?.settlementType;

  const prefillDocumentType = (documentTypeData: string): void => {
    form.setFieldsValue({ documentType: documentTypeData });
    onDocumentTypeChange(documentTypeData);
  };

  useEffect((): any => {
    if (isDraftBtnClicked && draftValue === 'settlement') {
      dispatch(setSettlementValue(eventValue));
      if (eventValue === 'settlement-docs') {
        setIsChangeBuddhi(true);
        setIsChangeCourier(false);
      } else if (eventValue === 'courier-track') {
        setIsChangeBuddhi(false);
        setIsChangeCourier(true);
      }
    }
    if (settlementType !== '') { // disabling button if upload settlement docs is selected and there are no files uploaded
      if (uploadedFiles?.length === 0) {
        dispatch(setModalSwitch(true));
      }
    } else {
      dispatch(setModalSwitch(true));
    }
    if (payer?.shortName === 'Bajaj') { // enabling submit button for Bajaj since there are no documents to be uploaded
      dispatch(setModalSwitch(false));
    }
  }, [eventValue]);

  useEffect((): void => {
    if (!isEmpty(selectedPatientDetail)) {
      const parsedValue = prefillHISDynamicFields(
        dischargeDetailsAdditionalAttrs?.documentsSubmitted,
        DYNAMIC_FIELD_MAPPINGS['documentType'],
      );
      if (parsedValue) {
        prefillDocumentType(parsedValue);
      }
      const parsedHISFieldValues = {
        dischargeDetailsAdditionalAttrs: getParsedAttributesObject(dischargeDetailsAdditionalAttrs),
        patientDetailsAdditionalAttrs: getParsedAttributesObject(patientDetailsAdditionalAttrs),
        dischargeInitiationDetails,
        caseDetails,
      };
      dispatch(setParsedHISValuesMap(parsedHISFieldValues));
      const formValues = fillFormValuesFromHIS(selectedPatientDetail, selectedPolicyDetail,
        newAdmissionSearchValues, memberName,
        payerLookUp[uniqueIdentifier], parsedHISFieldValues, null);
      form?.setFieldsValue(formValues);
    }
  }, [selectedPatientDetail]);

  const onChangeHandler = (event: any): any => {
    dispatch(updateSettlementType(event?.target?.value));
    if (event?.target?.value === 'settlement-docs') {
      setIsChangeCourier(false);
      setIsChangeBuddhi(true);
      customGTMEvent({
        event: 'Upload Settlement Documents',
      });
    } else if (event?.target?.value === 'courier-track') {
      setIsChangeBuddhi(false);
      setIsChangeCourier(true);
    }
    const { allowStatus } = claimDetails;
    const [{ actionName = null } = {}] = getNextAllowStatus(
      allowStatus, undefined, claimAction, isCorporatePayer, isCashlessSubmit,
    );
    claimDetails['nextAllowStatus'] = actionName ? [actionName] : [];
    dispatch(setClaimData({ ...claimDetails }));
  };

  const filterSelectedPayerEmails = (payerEmails: any = []): any => {
    const filteredPayerEmails = payerEmails.filter((pe: any): any => pe?.payerID === payer?.id);
    const { payerEmailIdForClaim = '' , payerEmailID = '' } = filteredPayerEmails[0] || {};
    setSelectedPayerEmails(!isEmpty(payerEmailIdForClaim) ? payerEmailIdForClaim : payerEmailID);
  };

  const onNoOfFilesChanged = (event: any): any => {
    dispatch(setExactFileCount(Number(event?.target?.value)));
  };

  const checkShowNow = (): any => {
    return (typeof policyEndDate === 'string' && policyEndDate?.length > 0) ?
      setIsShowNow(new Date(policyStartDate), new Date(policyEndDate)) : true;
  };
  return (
    <>
      <Row gutter={GUTTOR_SPACE}>
        <Col md={24}>
          <ClaimDetailHeader form={form} />
        </Col>
      </Row>
      { (isOnMailPayer || isRPAOutboundDisabledPayer) &&
      <><Row gutter={GUTTOR_SPACE}>
          <Col className="muti-payer-config-emails-wrapper">
            <p>{`Your Settlement will be sent to the following email`}</p>
            <p>
              {selectedPayerEmails?.length > 0 ? selectedPayerEmails : '-'}
            </p>
          </Col>
        </Row><Row gutter={GUTTOR_SPACE}>
            <FormMultiEmailInput detail={{
              ...commonDetail,
              key: 'additionalEmails',
              size: 24,
              compareWithAdditionlData: selectedPayerEmails.split(','),
            }} />
          </Row></>
      }
      <Row gutter={GUTTOR_SPACE}>
        <FormRadioButton
          detail={{
            ...commonDetail,
            key: 'settlementType',
            size: 12,
            onChange: onChangeHandler,
            hideLabel: true,
            direction: 'horizontal',
            options: [
              ...(!blockUploadSettlementdocs
                ? [
                  {
                    value: 'settlement-docs',
                    name: 'Upload Settlement documents',
                    disabled: settlementDocumentsDisabled,
                  },
                ]
                : []),
              // {
              //   value: 'courier-track',
              //   name: 'Track courier',
              //   disabled: false,
              // },
            ],
          }}
        />
      </Row>
      {
        settlementDocumentsDisabled && !isCourierChange ?
          <div className="error-text mr-10 d-inline-block">
            Settlement documents is not available for this payer. Please submit the documents directly to the payer.
          </div> :
          <Divider dashed={true} className="mt-0 mb-md" />
      }
      {
        isChangeBuddhi &&
        <React.Fragment>
          {
            payer?.shortName === 'PHSI' &&
            <Row gutter={GUTTOR_SPACE} className="mb-md">
              <FormSelect detail={{
                ...commonDetail,
                key: 'branch',
                size: 12,
                options: PARAMOUNT_SETTLEMENT_BRANCH_OPTIONS,
                required: true,
                hidden: false,
              }}
              />
            </Row>
          }
          {
            payer?.shortName === 'Bajaj' &&
            <>
              <Row gutter={GUTTOR_SPACE} className="mb-md">
                <FormTextInput detail={{
                  ...commonDetail,
                  key: 'courierName',
                  size: 12,
                  hidden: false,
                }}
                />
                <FormInputNumber detail={{
                  ...commonDetail,
                  key: 'consignmentNumber',
                  size: 12,
                  hidden: false,
                  allowClear: true,
                }}
                />
              </Row>
              <Row gutter={GUTTOR_SPACE} className="mb-md">
                <FormInputDate detail={{
                  ...commonDetail,
                  key: 'dispatchDate',
                  size: 12,
                  showTime: true,
                  allowClear: false,
                  hidden: false,
                }} />
              </Row>
            </>
          }
          {
            payer?.shortName === 'VIDAL' &&
            <Row gutter={GUTTOR_SPACE}>
              <FormCustomMaskedInput
                mask={MASKADHAAR}
                regxvalidator={AADHAR_VALIDATOR}
                detail={{
                  ...commonDetail,
                  key: 'aadharNo',
                  label: 'Aadhar No.',
                  placeholder: 'Enter your aadhar number',
                  size: 12,
                  required: false,
                  disabled: false,
                  hidden: false,
                }} />
              <FormTextInput
                detail={{
                  ...commonDetail,
                  key: 'settlementPan',
                  label: 'PAN No.',
                  hidden: false,
                  placeholder: 'Enter your PAN number',
                  size: 12,
                  required: false,
                  disabled: false,
                  rules: [panValidationUpload],
                }} />
            </Row>
          }
          {
            payer?.shortName === 'ICICI' &&
            <Row gutter={GUTTOR_SPACE}>
              <FormSelect detail={{
                ...commonDetail,
                key: 'typeOfClaim',
                label: 'Type of claim',
                size: 12,
                options: ICICI_TYPE_OF_CLAIM_OPTIONS,
                required: true,
                placeholder: 'Select',
                hidden: false,
              }}
              />
            </Row>
          }
          <Row gutter={GUTTOR_SPACE}>
            <Popconfirm
              placement="topRight"
              title={`The length of stay selected is for ${dateDifference} days. Is it correct?`}
              okText="Yes"
              cancelText="No"
              visible={isLOSgtWarning}
              onCancel={(): any => {
                setPopConfirmCancel(true);
                setIsLOSgtWarning(false);
              }}
              onConfirm={(): any => setIsLOSgtWarning(false)}
            >
              <DatePickerInput detail={{
                ...commonDetail,
                key: 'stayLength',
                size: 16,
                setval: (admitDate: any, dischargeDate: any, admitTime: any, dischargeTime: any): any => {
                  setSelectedTime(admitDate, dischargeDate, admitTime, dischargeTime);
                },
                setDifference: (noOfDays: number): any => { setDateDifference(noOfDays); },
                showNow: checkShowNow,
                disabled: (payer?.shortName === 'RGI' || payer?.shortName === 'ABHI') ? true : false,
                policyStartDate,
                policyEndDate,
                popConfirmCancel,
                isSettlement: true,         // to disable all the dates after today since it is a settlement flow
                isDetailPage: getIsPageNameDetail(pathname),
                claimForm: form,
              }} />
            </Popconfirm>
            <Col>
              <Row className="inpatient">
                <Col className="info-circle">

                  <Popover
                    content={'Inpatient | Daycare: Based on DOA & DOD'}
                    overlayClassName="custom-tooltip-datepicker"
                    placement="bottom"
                  >
                    <InfoCircleFilled />
                  </Popover>
                </Col>
                <DatePickerLabel dateDifference={dateDifference}/>
              </Row>
            </Col>
          </Row>
          {
            policyEndDate &&
            <Row gutter={GUTTOR_SPACE} className="mb-md">
              <Col>
                <Text type="secondary">
                  <InfoCircleTwoTone className="mr-5" />
                  Policy expiry date is {getDateWithTextMonth(policyEndDate)}.
                </Text>
              </Col>
            </Row>
          }
          {
            payer?.shortName === 'ICICI' &&
            <Row gutter={GUTTOR_SPACE}>
              <FormFormattedAmount detail={{
                ...commonDetail,
                key: 'claimedAmount',
                size: 12,
                required: true,
                addonBefore: '₹ ',
                placeholder: 'Enter Claimed Amount',
                allowClear: true,
                allowNegative: false,
                hidden: false,
              }} />
              <FormRadioButton detail={{
                key: 'documentSubmissionType',
                options: [...ICICI_DOCUMENT_SUBMISSION_OPTIONS],
                label: 'Uploaded via Web/Dispatch',
                size: 12,
                required: true,
                hidden: false,
              }} />
            </Row>
          }
          <Row gutter={GUTTOR_SPACE}>
            <FormCheckBox
              detail={{
                ...commonDetail,
                key: 'isDischargeCase',
                options: [{ value: 'Yes', name: 'Yes', onChange: dischargeSwitchHandler }],
                size: 12,
              }}
            />
            <FormRadioButton detail={{
              ...commonDetail,
              key: 'switchClick',
              options: [...RADIO_SWITCH_OPTION],
              onChange: nonUtilizedPA,
              isShowSuggestedValue: !!caseDetails,
            }} />
          </Row>
          {
            payer?.shortName === 'PHSI' &&
            <Row gutter={GUTTOR_SPACE}>
              <FormSelect detail={{
                ...commonDetail,
                key: 'documentType',
                size: 12,
                options: PARAMOUNT_SETTLEMENT_DOCUMENT_TYPE_OPTIONS,
                required: true,
                placeholder: 'Select document type',
                hidden: false,
              }}
              />
              <FormInputNumber detail={{
                ...commonDetail,
                key: 'noOfFiles',
                size: 12,
                required: true,
                hidden: false,
                onChange: (event: any, labelConfig: any): any => onNoOfFilesChanged(event),
              }} />
            </Row>
          }
          {
            payer?.shortName === 'VIDAL' &&
            <Row gutter={GUTTOR_SPACE}>
              <FormSelect detail={{
                ...commonDetail,
                key: 'documentType',
                label: 'Document submitted',
                size: 12,
                options: VIDAL_SETTLEMENT_DOCUMENT_TYPE_OPTIONS,
                required: true,
                placeholder: 'Select',
                hidden: false,
                onChange: (e: any): any => { onDocumentTypeChange(e); },
              }} />
              {
                docSubmittedByHandFieldsEnabled &&
                <FormTextInput
                  detail={{
                    ...commonDetail,
                    key: 'handedOverTo',
                    label: 'Handed over to (Person Name)',
                    placeholder: 'Enter name of the person',
                    size: 12,
                    required: true,
                    disabled: false,
                    hidden: false,
                  }} />
              }
              {
                docSubmittedByCourierFieldsEnabled &&
                <FormTextInput
                  detail={{
                    ...commonDetail,
                    key: 'podNo',
                    label: 'POD No.',
                    placeholder: 'Enter POD No.',
                    size: 12,
                    required: true,
                    disabled: false,
                    hidden: false,
                  }} />
              }
            </Row>
          }
          {
            docSubmittedByHandFieldsEnabled &&
            <Row gutter={GUTTOR_SPACE}>
              <FormInputDate
                detail={{
                  ...commonDetail,
                  key: 'dateOfDelivery',
                  label: 'Date & Time of delivery',
                  placeholder: 'Enter Date and Time of Delivery',
                  size: 12,
                  required: true,
                  showTime: true,
                  allowClear: true,
                }} />
            </Row>
          }
          {
            docSubmittedByCourierFieldsEnabled &&
            <>
              <Row gutter={GUTTOR_SPACE}>
                <FormInputDate
                  detail={{
                    ...commonDetail,
                    key: 'dateOfDispatch',
                    label: 'Date & Time of dispatch',
                    placeholder: 'Enter Date and Time of dispatch',
                    size: 12,
                    required: true,
                    showTime: true,
                    allowClear: true,
                  }} />
                <FormTextInput
                  detail={{
                    ...commonDetail,
                    key: 'courierAgencyName',
                    label: 'Name of the Courier Agency',
                    placeholder: 'Enter Name of the Courier Agency',
                    size: 12,
                    required: true,
                    disabled: false,
                  }} />
              </Row>
            </>
          }
          {
            <div className="w-100">
              {documentFlow === HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW ? <HISBuddhimedFileUpload form={form}
                showPreviouslyAddedFiles={!settlementDocuments}
                isSettlement={true} /> :
                documentFlow === NON_HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW ? <NonHISBuddhimedFileUpload
                  form={form} showPreviouslyAddedFiles={!settlementDocuments}
                  isSettlement={true} /> : <BuddhiMedFileUpload form={form} showPreviouslyAddedFiles={!settlementDocuments}
                    isSettlement={true} />}
            </div>
          }
          {
              settlementDocuments ? isPreAuthNewDesignEnabled ?
              <ClassifiedDocumentsRedesign form={form} settlementDocuments={settlementDocuments} /> :
              <ClassifiedDocuments form={form} settlementDocuments={settlementDocuments} />
              : null
          }
          <DocumentChecklist form={form} />
          <SettlementCard form={form} newFileUploads={newFileUploads} />
        </React.Fragment>
      }
      <div className="mt-lg w-100">
        {
          isCourierChange &&
          <CourierDetail form={form} />
        }
      </div>
    </>
  );
};

export default UploadSettlementDocs;
